export const checkIfAbsoluteUrl = (to: string): boolean => {
    let url: URL;

    try {
        url = new URL(to);
    } catch {
        return false;
    }

    return url.protocol === 'http:' || url.protocol === 'https:';
};
